import {Children, cloneElement} from 'react';

// adds "props" to "children"
export default (children, props = {}) =>
  Children.toArray(children)
    .filter(child => !!child)
    .map(child => cloneElement(child, props));



// WEBPACK FOOTER //
// ./shared/lib/addPropsToChildren.js